import React, { useState } from "react";
import { Link } from "react-router-dom";
import CoraaAIDialog from "./CoraaAIDialog";

const GIVFHeroSection = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [initialPrompt, setInitialPrompt] = useState("");
  return (
    <>
    <section
      className="relative py-20 min-h-[580px] flex flex-col md:flex-row items-center justify-between px-6 md:px-16 bg-[#0d1927] text-white overflow-hidden"
    >
      {/* Logo overlay (responsive) */}
      <Link to="/" className="absolute top-4 left-1/2 -translate-x-1/2 md:top-6 md:left-12 md:translate-x-0 z-20 flex justify-center md:block">
        <img
          src="/logo/twoliner-white.svg"
          alt="CauseConnect Logo"
          className="h-16 w-auto md:h-24"
        />
      </Link>

      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{
          backgroundImage: "url(/images/givf-hero-bg.jpg)",
        }}
        aria-hidden="true"
      ></div>

      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm z-0"
        aria-hidden="true"
      ></div>

      <div className="relative z-10 w-full flex flex-col md:flex-row items-center justify-between gap-12">
        {/* Left Content */}
        <div className="flex-1 max-w-2xl">
          <span className="inline-block mt-20 md:mt-0 bg-gradient-to-r from-yellow-400 via-pink-500 to-red-500 text-white text-xs md:text-sm px-4 py-2 rounded-full font-bold shadow mb-4 tracking-wider animate-bounce">
            GREAT INDIAN VOLUNTEERING FESTIVAL
          </span>
          <h1 className="text-4xl md:text-6xl font-extrabold mb-4 leading-tight text-white drop-shadow-xl">
            India’s Biggest <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-pink-500 to-red-500">Volunteering Movement</span>
          </h1>
          <div className="flex flex-wrap gap-2 mb-4">
            <span className="bg-white/10 text-yellow-300 font-semibold px-3 py-1 rounded-full text-xs md:text-sm">June 5 – Sept 5, 2025</span>
            <span className="bg-white/10 text-pink-200 font-semibold px-3 py-1 rounded-full text-xs md:text-sm">16+ Cities</span>
            <span className="bg-white/10 text-green-200 font-semibold px-3 py-1 rounded-full text-xs md:text-sm">300+ Experiences</span>
            <span className="bg-white/10 text-blue-200 font-semibold px-3 py-1 rounded-full text-xs md:text-sm">100+ Nonprofits</span>
          </div>
          <p className="text-lg md:text-2xl font-semibold text-white mb-2">
            Discover. Book. Track impact. <span className="text-green-300">Powered by CORAA AI</span>
          </p>
          <p className="text-base md:text-lg text-white/80 mb-6 max-w-xl">
            Plug-and-play CSR & volunteering campaigns for companies and nonprofits. All-inclusive, transparent, and AI-powered for effortless impact.
          </p>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => {
                setInitialPrompt("Show me volunteering opportunities for june and september");
                setDialogOpen(true);
              }}
              className="bg-green-600 hover:bg-green-700 px-6 py-3 rounded-lg text-lg font-semibold shadow"
            >
              Explore Events
            </button>
            <Link 
              to="/corporate"
              className="inline-flex items-center justify-center bg-white text-green-700 hover:bg-gray-100 px-6 py-3 rounded-lg text-lg font-semibold shadow border border-green-600"
            >
              For Companies
            </Link>
          </div>
        </div>

    {/* Right: India Map with GIVF Cities */}
<div className="flex-1 flex justify-center items-center relative max-w-[500px] w-full h-auto">
  {/* Static India Map SVG Image */}
  <img
    src="/images/india.svg"
    alt="India Map"
    className="w-full h-auto object-contain"
  />

  {/* City Dots Overlay */}
  <svg
    viewBox="0 0 1000 1000" // Adjust this viewBox to match your india.svg's actual viewBox
    className="absolute top-0 left-0 w-full h-full pointer-events-none"
  >
    {[
      { name: "Delhi", x: 290, y: 250 },
      { name: "Gurgaon", x: 305, y: 290 },
      { name: "Noida", x: 358, y: 320 },
      { name: "Ludhiana", x: 260, y: 200 },
      { name: "Lucknow", x: 480, y: 380 },
      { name: "Ahmedabad", x: 90, y: 520 },
      { name: "Mumbai", x: 180, y: 640 },
      { name: "Pune", x: 260, y: 680 },
      { name: "Hyderabad", x: 390, y: 650 },
      { name: "Vizag", x: 600, y: 590 },
      { name: "Bangalore", x: 300, y: 780 },
      { name: "Chennai", x: 440, y: 850 },
      { name: "Coimbatore", x: 290, y: 875 },
      { name: "Kochi", x: 290, y: 920 },
      { name: "Trivandrum", x: 300, y: 1000 },
      { name: "Kolkata", x: 660, y: 480 },
    ].map((city, index) => (
      <g key={index}>
        <circle cx={city.x} cy={city.y} r="6" fill="#4caf50" />
        <text
          x={city.x + 8}
          y={city.y + 4}
          fontSize="25"
          fill="white"
          fontWeight="500"
        >
          {city.name}
        </text>
      </g>
    ))}
  </svg>
</div>



      </div>
    </section>
    <CoraaAIDialog 
      open={dialogOpen} 
      onClose={() => {
        setDialogOpen(false);
        setInitialPrompt("");
      }} 
      initialInput={initialPrompt}
    />
    </>
  );
};

export default GIVFHeroSection;